import {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import InputAmount from '../../../../../component/input/inputAmount/InputAmount';
import {useField} from 'formik';
import InputList from '../../../../../component/input/inputList/InputList';
import TextareaInput from '../../../../../component/input/textareaInput/TextareaInput';
import CheckboxFormik from '../../../../../component/checkboxFormik/CheckboxFormik';
import {getCrowds} from '../../../../../redux/crowds/crowdsActions';
import AccountPermission from '../../../../components/accountPermission/AccountPermission';
import Committees from '../committees/Committees';
import * as css from './PaymentsGlobal.css';

function PaymentsGlobal({children}) {
    const {t} = useTranslation('ticket');
    const globalT = useTranslation('global').t;
    const crowds = useSelector((state) => state?.crowds?.crowds);
    const eventType = useSelector((state) => state.event.type);
    const clubsSettings = useSelector((state) => state.event.settings?.clubs);
    const [isMemberLimitField] = useField('crowd.isMemberLimit');
    const [crowdCridField] = useField('crowd.crid');
    const consumerClubs = useSelector((state) => state.account.consumerClubs);
    
    const hasActiveClubSetting = clubsSettings && 
        Object.values(clubsSettings).some(setting => 
            !Array.isArray(setting) && (setting === true || setting === 1)
        );

    const getCrowdsList = () => {
        if(crowds) {
            let copyCrowds = [...crowds];
            return [{crid: null, title: t('noCrowd')}, ...copyCrowds].map((i) => ({
                ...i,
                text: i.title,
                key: i.crid,
            }));
        } else
            return [{crid: null, title: t('noCrowd')}].map((i) => ({
                ...i,
                text: i.title,
                key: i.crid,
            }));
    };

    useEffect(() => {
        if(!crowds?.crowds) {
            const fetchData = async () => {
                await getCrowds();
            };
            fetchData();
        }
    }, []);

    const inputRef=useRef(null);
    const listProps={
        fixedTop:true,
        top: inputRef.current?.getBoundingClientRect().y+inputRef.current?.offsetHeight,
        left:inputRef.current?.getBoundingClientRect().x
    };

    return (
        <>
            <css.wrapAll>
                {!!children && (
                    <>
                        <css.text>{t('billingAndPaymentSettings')}</css.text>
                        {children}
                    </>
                )}
                <css.wrapSettings>
                    <css.text>{t('advancedTicketSettings')}</css.text>
                    <TextareaInput name={'text'} text={t('ticketText')} />
                    <AccountPermission permission={'crowds'}>
                        <css.wrapGrid>
                            <css.wrapCrowd ref={inputRef}>
                                <InputList
                                    width={'320px'}
                                    text={t('associatingTicket')}
                                    description={t('associatingTicketDesc')}
                                    list={getCrowdsList()}
                                    name="crowd.crid"
                                    t={t}
                                    listProps={listProps}
                                />
                            </css.wrapCrowd>
                            <InputAmount
                                name={'crowd.limit'}
                                text={t('limitCrowd')}
                                description={t('limitCrowdDesc')}
                                amountText={globalT('pcs')}
                                disabled={isMemberLimitField.value}
                            />
                        </css.wrapGrid>
                        {crowdCridField.value !== null && (
                            <css.wrapCB>
                                <CheckboxFormik
                                    name={'crowd.isMemberLimit'}
                                    text={t('isMemberLimit')}
                                />
                            </css.wrapCB>
                        )}
                    </AccountPermission>
                </css.wrapSettings>

                {['area', 'ticket'].includes(eventType) && consumerClubs.length > 0 && hasActiveClubSetting && <AccountPermission permission="consumer clubs" >
                    <Committees />
                </AccountPermission>}
            </css.wrapAll>
        </>
    );
}
export default PaymentsGlobal;
